import { useContext } from 'react'
import { Column } from '../../../core/Components'
import { ModalComponents } from '../../../core/Modal'
import { FileItem, ProjectFilePicker } from './components'
import { RegisterModalContext } from './RegisterSongModal'

export const UploadProjectPage = () => {
  const { state, clearProjectFile } = useContext(RegisterModalContext)

  return (
    <>
      <ModalComponents.HeaderContainer>
        <ModalComponents.Title>
          Upload a project file to automatically credit samples (Optional)
        </ModalComponents.Title>
        <ModalComponents.Subtitle>
          If you used Live or FL Studio, upload your project file to automatically credit the
          samples you used in your song.
        </ModalComponents.Subtitle>
      </ModalComponents.HeaderContainer>
      <ModalComponents.Container>
        <Column>
          <ProjectFilePicker />
          {state.projectFileField.value && (
            <FileItem.Success
              file={state.projectFileField.value}
              handleDelete={(_file) => clearProjectFile()}
            />
          )}
          {state.projectFileField.errors?.map((error, index) => (
            <FileItem.Error fileError={error} key={index} />
          ))}
        </Column>
      </ModalComponents.Container>
    </>
  )
}
